<template>
  <div>
    <div class="text-base" v-html="isShown ? this.initialText : this.shortText"></div>
    <div class="text-base show-more-prompt" @click="isShown = !isShown">
      {{ isShown ? 'Weniger anzeigen' : 'Mehr anzeigen' }}
      <img :class="isShown ? '' : 'rotate'" src="/files/lidl/images/new-icons/svg/chevron-right.svg" alt=""/>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ShowMore',
  data() {
    return {
      isShown: false
    }
  },
  props: {
    splitLength: {
      type: Number,
      default: 500
    },
    initialText: {
      type: String,
      default: '',
      required: true
    }
  },
  methods: {},
  computed: {
    shortText() {
      return this.initialText.slice(0, this.splitLength) + '...'
    }
  }
}
</script>
